import React from 'react';
import { useCreateUser } from '../Providers/CreateUserProvider/CreateUserContext';

const PreviewAndSave: React.FC = () => {
  const { createUserData } = useCreateUser();
  const user = createUserData;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 text-sm text-slate-900">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold">
          {user.userId} <span className="text-purple-600 text-sm font-medium">● New</span>
        </h2>
      </div>

      {/* Info Section */}
      <div className="mb-6">
        <h3 className="text-blue-600 font-semibold mb-3">Info</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-gray-500 text-sm">User Name</p>
            <p className="font-medium break-words">{user.userName}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Email</p>
            <p className="font-medium break-all max-w-full">{user.email}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Mobile No</p>
            <p className="font-medium break-words">{user.mobileNo}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Department</p>
            <p className="font-medium break-words">{user.departmentName}</p>
          </div>
        </div>
      </div>

      {/* Contact Details Section */}
      <div className="mb-6">
        <h3 className="text-blue-600 font-semibold mb-3">Contact Details</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <p className="text-gray-500 text-sm">Address</p>
            <p className="font-medium break-words">{user.address}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Street</p>
            <p className="font-medium break-words">{user.street}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">City</p>
            <p className="font-medium break-words">{user.city}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">State</p>
            <p className="font-medium break-words">{user.state}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Country</p>
            <p className="font-medium break-words">{user.country}</p>
          </div>
        </div>
      </div>

      {/* Role Section */}
      <div>
        <h3 className="text-blue-600 font-semibold mb-3">Role</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <p className="text-gray-500 text-sm">Role</p>
            <p className="font-medium break-words">{user.roleName}</p>
          </div>
          <div>
            <p className="text-gray-500 text-sm">Shift</p>
            <p className="font-medium break-words">{user.shift}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewAndSave;
